import React, { Component } from 'react'
import ReactModal from 'react-modal'
import { inject, observer } from 'mobx-react'
import styled, { ThemeProvider } from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'

import FixedCloseButton from '~/components/modals/FixedCloseButton'
import MODAL_STYLES from '~/components/modals/styles'

import PasswordlessLogin from '~/components/auth/PasswordlessLogin'
import ContinueWithButtons from '~/components/auth/ContinueWithButtons'
import ErrorText from '~/components/Form/ErrorText'
import SectionHeader from '~/components/Pages/SectionHeader'
import Spacer from '~/components/Spacer'
import Center from '~/components/basic/Center'
import Car from "~/public/static/images/png/car.png"

const LoginContainer = styled.div`
  ${props => (props.isMobile ? null : 'max-width: 300px;')}
  width: 100%;
`

const BackgroundLayerOne = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  background-image: url(${Car});
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-size: 377px 136px;
  padding: ${props => props.isMobile ? 1: 2}rem;
`

const FlexBoxGridTheme = {
  flexboxgrid: {
    gridSize: 2,
    gutterWidth: '1',
    outerMargin: '0',
    mediaQuery: 'only screen',
    container: {
      sm: 38,
      md: 46,
      lg: 76
    },
    breakpoints: {
      xs: 0,
      sm: 38,
      md: 50,
      lg: 75
    }
  }
}

const COL_PROPS = {
  lg: 1,
  md: 1,
  sm: 2,
  xs: 2,
}

@inject(all => ({
  isMobile: all.store.ui.isMobile,
  auth: all.store.auth,
  isLoggedIn: all.store.auth.isLoggedIn,
  loginModalShowing: all.store.ui.loginModalShowing,
  setLoginModalShowing: all.store.ui.setLoginModalShowing,
  setSignupModalShowing: all.store.ui.setSignupModalShowing,
}))
@observer
class LoginModal extends Component {
  componentDidUpdate(prevProps) {
    if(!prevProps.isLoggedIn && this.props.isLoggedIn) {
      this.hideModal()
    }
  }

  openModal = () => {
    this.props.auth.resetLogin()
    this.props.setLoginModalShowing(true)
  }

  hideModal = () => this.props.setLoginModalShowing(false)

  render() {
    const { isMobile, auth } = this.props
    const asyncError = auth.validateDisplayMessage('asyncError')
    return (
      <>
        <ReactModal
          closeTimeoutMS={300}
          isOpen={this.props.loginModalShowing}
          style={
            isMobile
              ? MODAL_STYLES.mobile.generalNoPadding
              : MODAL_STYLES.desktop.generalNoPadding
          }
          contentLabel="Login to your winit account"
          onRequestClose={this.hideModal}
        >
          <FixedCloseButton color={this.props.isMobile ? 'black' : 'white'} onClick={this.hideModal} />
          <ThemeProvider theme={FlexBoxGridTheme}>
            <BackgroundLayerOne isMobile={isMobile}>
              <SectionHeader title="Sign In" />
              <Spacer mobile={10} desktop={20} />
              <Spacer mobile={10} desktop={20} />
              {asyncError ? (
                <Center>
                  <ErrorText margin="5px 0 10px 0" fontSize="1rem" error={asyncError} />
                </Center>
              ) : null}
              <Grid style={{width: '100%'}}>
                <Row>
                  <Col {...COL_PROPS}>
                    <Center>
                      <LoginContainer isMobile={isMobile}>
                        <PasswordlessLogin />
                      </LoginContainer>
                    </Center>
                  </Col>

                  <Col {...COL_PROPS}>
                    <Center fillParent={false}>
                      <LoginContainer isMobile={isMobile}>
                        <ContinueWithButtons alignWithEmailField />
                      </LoginContainer>
                    </Center>
                  </Col>
                </Row>
              </Grid>
            </BackgroundLayerOne>
          </ThemeProvider>
        </ReactModal>
        {!this.props.auth.isLoggedIn ? (
          <this.props.opener onClick={this.openModal} />
        ) : null}
      </>
    )
  }
}

export default LoginModal
